module.exports = "pegasus/assets/email1-column-1.png";